import React, { Component } from 'react'
import { compact } from 'lodash'
import InfoCard from 'components/Cards/InfoCard'
import Button from 'components/Button'
import SimpleTable from 'components/Tables/SimpleTable'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sMarg from 'styles/modules/margins.scss'

export default class BillingAccountCard extends Component {
  render() {
    const { billingAccount } = this.props
    const addressString = compact([
      billingAccount.address,
      billingAccount.suburb,
      billingAccount.state,
      billingAccount.postalCode,
    ]).join(', ')
    return (
      <InfoCard className={sMarg.mb30} title={billingAccount.name}>
        <SimpleTable>
          <div>
            <div>Account Number (ban):</div>
            <div>{billingAccount.ban}</div>
          </div>
          {addressString && (
            <div>
              <div>Address:</div>
              <div>{addressString}</div>
            </div>
          )}
          {billingAccount.invoiceDelivery && (
            <div>
              <div>Invoice Email:</div>
              <div>{billingAccount.invoiceDelivery}</div>
            </div>
          )}
          {billingAccount.paymentTerms && (
            <div>
              <div>Payment Terms:</div>
              <div>{billingAccount.paymentTerms}</div>
            </div>
          )}
          {billingAccount.directDebitMethod === 'Credit Card' && (
            <>
              <div>
                <div>Credit Card Number:</div>
                <div>xxxx-xxxx-xxxx-{billingAccount.creditCardLast4Digits}</div>
              </div>
              <div>
                <div>Credit Card Expiry:</div>
                <div>{billingAccount.creditCardExpire}</div>
              </div>
            </>
          )}
          {billingAccount.directDebitMethod === 'Bank Account' && (
            <div>
              <div>Bank Account:</div>
              <div>
                {billingAccount.bankAccountBsb} / xxxxx{billingAccount.bankAccountLast4Digits}
              </div>
            </div>
          )}
        </SimpleTable>
        <br />
        <div className={cn(sLay['layout-row'], sLay['layout-align-end'])}>
          <Button
            color="tertiary"
            ghost
            to={`/dashboard/billing/accounts/${billingAccount.ban}`}
            size="sm"
          >
            Edit
          </Button>
        </div>
      </InfoCard>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAccountCard/BillingAccountCard.jsx